import { arrayUnion } from 'firebase/firestore';
import { updateUser } from '../profile/api';
import { getFcmToken } from '../firebase';

/**
 * Fetches a fresh FCM token and saves it to the user's Firestore doc.
 * Firebase SDK returns the cached token if still valid, or a new one if rotated.
 * Called on every app load so Firestore always has the current token.
 *
 * @param {string} userUid - Firebase Auth UID (== Firestore document ID for users)
 */
export const addMessagingTokenToUser = async userUid => {
  try {
    let token = await getFcmToken();

    // Token is null when notification permission hasn't been granted yet — request it.
    // Notification doesn't exist on iOS Safari/webviews — skip silently there.
    if (!token && typeof Notification !== 'undefined' && Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        token = await getFcmToken();
      }
    }

    if (token) {
      // Multi-device: add this device's token to the array (deduped by arrayUnion),
      // and keep `messageToken` as the latest one for backward compatibility.
      await updateUser(userUid, { messageTokens: arrayUnion(token), messageToken: token });
    }
  } catch (err) {
    console.warn('[FCM] Error refreshing token:', err);
  }
};
